import React, { Component } from 'react';
import CloudZenythApp from './components/general/AdminSoftApp'
// import './App.css';
// import './bootstrap.css';
import './assets/css/main.scss';

class CloudZenyth extends Component {
  render() {
    return (
      <div className="App">
        <CloudZenythApp />
      </div>
    );
  }
}

export default CloudZenyth;